import { render, staticRenderFns } from "./MedicationInput.vue?vue&type=template&id=555cb717&scoped=true"
import script from "./MedicationInput.vue?vue&type=script&lang=js"
export * from "./MedicationInput.vue?vue&type=script&lang=js"
import style0 from "./MedicationInput.vue?vue&type=style&index=0&id=555cb717&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555cb717",
  null
  
)

export default component.exports